define('../cloud-pro/js/showIframe',['require','exports','module','../../cloud-pro/js/xray','body-scroll-lock'],function(require, exports, module) {
    var xray = require('../../cloud-pro/js/xray');
    var scrollLock = require('body-scroll-lock');
    var className = 'buy-iframe';
    var $body = $('body');

    var buyIframe = document.getElementById('buy-iframe-container');
    var iframeElem = document.createElement('iframe');
    var iframeSize = {
        width: 834,
        height: 650
    };
    var messages = {
        size: 'SIZE',
        close: 'CLOSE',
        success: 'SUCCESS'
    };
    var successPay = false;

    function showPopup() {
        var $popupSuccess = $('#popup-succes');

        $popupSuccess.on('click', '[data-action=close]', function(event) {
            event.preventDefault();
            $popupSuccess.hide();
        });

        $popupSuccess.show();
    }

    window.addEventListener('message', function(event) {
        if (!event|| !event.data) {
            return;
        }

        var message = '';

        try {
            message = JSON.parse(event.data);
        } catch (e) {}

        if (!message || !message.type) {
            return;
        }

        switch (message.type) {
            case messages.size:
                var wrapperHeight = 139;
                iframeElem.height = (Number(message.height) || iframeSize.height) + wrapperHeight;
                break;
            case messages.success:
                successPay= true;
                break;
            case messages.close:
                destroyIframe();

                if (successPay) {
                    showPopup();
                }

                break;
        }
    });

    var onClickOutside = function(e) {
        if (e.target.className.indexOf(className) !== -1) {
            return;
        }

        destroyIframe();
    };

    var destroyIframe = function() {
        scrollLock.enableBodyScroll($body);
        buyIframe.innerHTML = '';
        buyIframe.classList.toggle('show');
        document.removeEventListener('click', onClickOutside);
    };

    var showIframe = function(tariffId) {
        var params = xray.defaultParams();

        iframeElem.width = iframeSize.width;
        iframeElem.height = iframeSize.height;
        iframeElem.frameborder = 'no';
        iframeElem.classList.add(className);
        iframeElem.src = '/buy?tariff_id=' + tariffId + '&clientId=' + params.client_id + '&group=' + params.group + '&from=landingPro';
        buyIframe.innerHTML = '';
        buyIframe.append(iframeElem);
        buyIframe.classList.toggle('show');
        scrollLock.disableBodyScroll($body, {
            reserveScrollBarGap: true
        });

        document.addEventListener('click', onClickOutside);
    };

    if (location.search && /(^|[?&])from-auth=1([&]|$)/i.test(location.search)) {
        var newUrl = new URL(location.href);
        var tariffId = newUrl.searchParams.get('tariff-id');
        newUrl.searchParams.delete('from-auth');
        newUrl.searchParams.delete('tariff-id');
        history.pushState('', document.title, newUrl);

        showIframe(tariffId);
    }

    module.exports = showIframe;
});

